import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-38fd3ad1"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "cms-card-block"
};
const _hoisted_3 = {
  class: "btn-warp"
};
const _hoisted_4 = {
  class: "table-select-warp"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = ["onDblclick"];
const _hoisted_9 = {
  key: 0
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import AddSeriesFilm from '../components/AddSeriesFilm/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import { nextTick } from 'vue';
import { elMessage } from '@/utils';
import { messageBox } from '@/utils/validate';
import { AUDIT_STATUS_NEW, RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { getAddProgramInfoApi, deleteSetProgramIdsApi, editSetSequenceApi, addProgramInfoApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const isShowAddSeriesFilm = ref(false);
    const TYPE_OPTION = {
      movie: t('单片'),
      tv_series: t('剧集')
    }; // 标题配置

    const headerConfig = reactive({
      title: '列表',
      btnList: [{
        label: '返回',
        func: () => {
          emit('update:modelValue', false);
          emit('update-list');
        }
      }]
    });
    const dialogConfig = reactive({
      visible: false,
      action: '',
      config: {
        title: '提示'
      },
      confirm: () => {// handleBatchRemove();
      }
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      config: {
        loading: false
      },
      oldIndex: 0
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection'
      }, {
        label: '影片名称',
        prop: 'programName'
      }, {
        label: '类型',
        prop: 'programType',
        formatter: value => TYPE_OPTION[value]
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        cellSlot: true
      }, {
        label: '审核状态',
        prop: 'auditStatus',
        cellSlot: true
      }, {
        label: '语言',
        prop: 'audioLanguage'
      }, {
        label: '排序',
        prop: 'sequence',
        cellSlot: true
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        buttonsList: [{
          label: '移除',
          func: row => {
            if (tableConfig.data.length === 1 && props.detailInfo.releaseStatus === 'online') return elMessage('warning', '上线系列至少保留一条影片');
            messageBox('确定删除这条数据吗?').then(async () => {
              handleRemoveItem([row]);
            });
          }
        }]
      }]
    }); // 移除点击事件

    const handleRemoveItem = async row => {
      try {
        let params = {
          programList: [],
          videoSeriesId: props.detailInfo.id
        };
        row.forEach(item => {
          params.programList.push({
            programId: item.programId,
            programType: item.programType
          });
        });
        const res = await deleteSetProgramIdsApi(params);

        if (res.code == '0') {
          elMessage('success', '删除成功');
          dialogConfig.visible = false;
          getAddProgramInfo();
        }
      } catch (error) {
        console.log('173-error', error);
      }
    };

    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    };

    const editCell = ref('');

    const onEditCell = scope => {
      editCell.value = `${scope.$index}-${scope.column.no}`;
      nextTick(() => {
        const input = document.querySelector('.EL__focus .el-input__inner');
        input.focus();
      });
    }; // 修改排序输入框获取焦点事件


    const onSIndexFocus = row => {
      // 因为编辑时会改变之前的 index，所以要记住之前的 index
      tableConfig.oldIndex = row.sequence;
    }; // 修改排序输入框丢失焦点事件


    const onSIndexBlur = async row => {
      let sequence = row.sequence;

      if (sequence === '' || Number(sequence) === 0) {
        row.sequence = tableConfig.oldIndex;
        editCell.value = '';
      } else if (row.sequence !== tableConfig.oldIndex) {
        try {
          let params = {
            videoSeriesId: props.detailInfo.id,
            programId: row.programId,
            sequence,
            programType: row.programType
          };
          const res = await editSetSequenceApi(params);

          if (res.code == '0') {
            elMessage('success', '修改成功');
            getAddProgramInfo();
          } else {
            row.sequence = tableConfig.oldIndex;
          }
        } catch (error) {
          row.sequence = tableConfig.oldIndex;
        }

        editCell.value = '';
      } else {
        editCell.value = '';
      }
    };

    const onInput = (e, row) => {
      row.sequence = e.replace(/[^\d]/g, '');

      if (e > tableConfig.data.length) {
        row.sequence = tableConfig.paginationConfig.total;
      }
    }; // 添加影片按钮点击事件


    const showSeriesFilm = () => {
      isShowAddSeriesFilm.value = true;
    }; // 批量移除按钮点击事件


    const handleBatchRemoveClick = () => {
      if (selectTableConfig.selectData.length === 0) return elMessage('warning', '请先勾选影片');
      if (selectTableConfig.selectData.length === tableConfig.data.length && props.detailInfo.releaseStatus === 'online') return elMessage('warning', '上线系列至少保留一条影片'); // dialogConfig.visible = true;

      messageBox('是否要移除所选?').then(async () => {
        const ids = selectTableConfig.selectData.map(item => item.id);
        handleRemoveItem(selectTableConfig.selectData);
      });
    }; // 子组件返回事件


    const goBack = () => {
      isShowAddSeriesFilm.value = false;
    }; // 子组件添加影片按钮点击事件


    const addList = async data => {
      try {
        let programList = data.map(item => {
          return {
            programId: item.id,
            programType: item.programType
          };
        });

        if (programList.length > 0) {
          let params = {
            videoSeriesId: props.detailInfo.id,
            // cid: Number(sessionStorage.getItem('currentCid')),
            programList
          };
          const res = await addProgramInfoApi(params);

          if (res.code == '0') {
            elMessage('success', '新增成功');
            isShowAddSeriesFilm.value = false;
            getAddProgramInfo();
          } else {
            isShowAddSeriesFilm.value = false;
          }
        } else {
          isShowAddSeriesFilm.value = false;
        }
      } catch (error) {
        isShowAddSeriesFilm.value = false;
      }
    }; // 批量移除
    // const handleBatchRemove = () => {
    //     const ids = selectTableConfig.selectData.map(item => item.id)
    //     handleRemoveItem(ids)
    // }
    // 获取表格列表数据


    const getAddProgramInfo = async () => {
      try {
        tableConfig.config.loading = true;
        let params = {
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          videoSeriesId: props.detailInfo.id
        };
        const res = await getAddProgramInfoApi(params);

        if (res.code == '0') {
          tableConfig.data = res.data ? res.data : [];
          tableConfig.paginationConfig.total = res.total;
          tableConfig.config.loading = false;
        } else {
          tableConfig.config.loading = false;
        }
      } catch (error) {
        tableConfig.config.loading = false;
      }
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = columnConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    const tableRef = ref();

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    watch(() => props.modelValue, val => {
      if (val) {
        getAddProgramInfo();
      } else {
        tableConfig.data = [];
        tableConfig.paginationConfig = usePageConfig();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_el_input = _resolveComponent("el-input");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_MDialog = _resolveComponent("MDialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", null, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: showSeriesFilm
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加影片')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, {
        disabled: selectTableConfig.selectData.length === 0,
        style: {
          "min-width": "120px"
        },
        onClick: handleBatchRemoveClick,
        type: "danger"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('批量移除')), 1)]),
        _: 1
      }, 8, ["disabled"])]), _createVNode(_component_TableColumnOptionBtn, {
        "column-list": columnConfig.columnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_common_table, {
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getAddProgramInfo,
        onSelectionChange: handleSelectionChange,
        options: tableConfig.config
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property === 'releaseStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 1)) : _createCommentVNode("", true), scope.column.property === 'auditStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(AUDIT_STATUS_NEW)[scope.row.auditStatus]), 1)) : _createCommentVNode("", true), scope.column.property === 'sequence' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [editCell.value != `${scope.$index}-${scope.column.no}` ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "pointer",
            style: {
              "display": "inline-block",
              "width": "100%"
            },
            onDblclick: $event => onEditCell(scope)
          }, _toDisplayString(scope.row.sequence), 41, _hoisted_8)) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            maxlength: "6",
            class: "EL__focus",
            modelValue: scope.row.sequence,
            "onUpdate:modelValue": $event => scope.row.sequence = $event,
            placeholder: _ctx.$t('请输入序号'),
            onFocus: $event => onSIndexFocus(scope.row),
            onBlur: $event => onSIndexBlur(scope.row),
            onInput: e => onInput(e, scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onFocus", "onBlur", "onInput"]))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "options"])])])], 512), [[_vShow, !isShowAddSeriesFilm.value]]), isShowAddSeriesFilm.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(AddSeriesFilm, {
        "detail-info": __props.detailInfo,
        onGoBack: goBack,
        onAddList: addList
      }, null, 8, ["detail-info"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_MDialog, {
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%'
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('是否要移除所选?')), 1)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});